import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { SYNCHRONIZE } from './types';

export const synchronize = createTaskAction(SYNCHRONIZE);
